import type { TractorListResponse } from '@contracts/tractor/TractorListResponse';
import type { TractorRequest } from '@contracts/tractor/TractorRequest';
import type { TractorWithAxlesResponse } from '@contracts/tractor/TractorWithAxlesResponse';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import { TractorList } from '@src/tractor/domain/Tractor';

export const TractorClient = {
  list: async (clientId: string) => {
    const { data: response } =
      await AuthenticatedClient.get<TractorListResponse>(
        `clients/${clientId}/tractors`,
      );

    return new TractorList(response.tractors);
  },
  get: async (clientId: string, tractorId: string) => {
    const { data: response } =
      await AuthenticatedClient.get<TractorWithAxlesResponse>(
        `clients/${clientId}/tractors/${tractorId}`,
      );

    return response;
  },
  create: async (
    clientId: string,
    data: unknown,
  ): Promise<TractorWithAxlesResponse> => {
    const { data: response } =
      await AuthenticatedClient.post<TractorWithAxlesResponse>(
        `clients/${clientId}/tractors`,
        data,
      );

    return response;
  },
  update: async (
    clientId: string,
    tractorId: string,
    data: TractorRequest,
  ): Promise<TractorWithAxlesResponse> => {
    const { data: response } =
      await AuthenticatedClient.put<TractorWithAxlesResponse>(
        `clients/${clientId}/tractors/${tractorId}`,
        data,
      );

    return response;
  },
  delete: async (clientId: string, tractorId: string): Promise<void> => {
    await AuthenticatedClient.post<void>(
      `clients/${clientId}/tractors/${tractorId}/delete`,
    );
  },
};
